import { TRESPONSE_BUNDLE_LINE_IN_ACTIVITY_LOG, TRESPONSE_BUNDLE_LINE_IN_TRANSACTION_LOG } from '@monorepo/types';

export type TBundleLineInState = {
  transactionLogInfo: TRESPONSE_BUNDLE_LINE_IN_TRANSACTION_LOG | null;
  activityLogInfo: TRESPONSE_BUNDLE_LINE_IN_ACTIVITY_LOG | null;
  restoreCount: number;
};

export const TBundleLineInActionType = {
  GetTransactionLog: 'GET_TRANSACTION_LOG_BUNDLE_LINE_IN' as const,
  GetTransactionLogSuccess: 'GET_TRANSACTION_LOG_BUNDLE_LINE_IN_SUCCESS' as const,
  GetTransactionLogFailure: 'GET_TRANSACTION_LOG_BUNDLE_LINE_IN_FAILURE' as const,
  GetActivityLog: 'GET_ACTIVITY_LOG_BUNDLE_LINE_IN' as const,
  GetActivityLogSuccess: 'GET_ACTIVITY_LOG_BUNDLE_LINE_IN_SUCCESS' as const,
  GetActivityLogFailure: 'GET_ACTIVITY_LOG_BUNDLE_LINE_IN_FAILURE' as const,
  GetRestoreCount: 'GET_RESTORE_COUNT_BUNDLE_LINE_IN' as const,
  GetRestoreCountSuccess: 'GET_RESTORE_COUNT_BUNDLE_LINE_IN_SUCCESS' as const,
  GetRestoreCountFailure: 'GET_RESTORE_COUNT_BUNDLE_LINE_IN_FAILURE' as const,
};
